import axios from 'axios';

export type IFlarelaneTag = Record<string, string>;

interface IPatchFlarelaneUserTags {
  userId: string;
  tags: IFlarelaneTag;
}

export const patchFlarelaneUserTags = ({ userId, tags }: IPatchFlarelaneUserTags) => {
  return axios.patch(
    `https://api.flarelane.com/v1/projects/${process.env.REACT_APP_FLARELANE_PROJECT_ID}/users/tags`,
    { userId, tags },
    {
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_FLARELANE_API_KEY}`,
      },
    },
  );
};
